import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Button, Container, Grid, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { createProductCategory, getProductCategory, updateProductCategory } from '../services/Common/productCategories.service';
import { toast } from 'react-toastify';

const empty = { name: '', slug: '', status: 'active', image: '', icon: '', description: '', displayOrder: 0 };

export default function ProductCategoryForm() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (!isEdit) return;
      try {
        const res = await getProductCategory(id);
  const item = res.data || res.category || res.result || res;
  const status = (item.status || 'active').toLowerCase();
      setForm({ name: item.name || '', slug: item.slug || '', status, image: item.image || '', icon: item.icon || '', description: item.description || '', displayOrder: item.displayOrder || 0 });
      } catch (e) { toast.error(e?.response?.data?.message || 'Failed to load category'); }
    };
    load();
  }, [id, isEdit]);

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      const payload = { ...form };
      if (isEdit) await updateProductCategory(id, payload); else await createProductCategory(payload);
      toast.success(isEdit ? 'Category updated' : 'Category created');
      navigate('/products/categories');
    } catch (e) { toast.error(e?.response?.data?.message || 'Save failed'); }
    finally { setSaving(false); }
  };

  return (
    <>
      <Helmet><title>{isEdit ? 'Edit' : 'Create'} Category | Trooper</title></Helmet>
      <Container>
        <Stack direction='row' alignItems='center' justifyContent='space-between' mb={3}>
          <Typography variant='h4'>{isEdit ? 'Edit' : 'Create'} Category</Typography>
        </Stack>
        <Box component='form' onSubmit={onSubmit} sx={{ maxWidth: 720 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}><TextField fullWidth label='Name' value={form.name} onChange={e=>setForm(f=>({...f, name:e.target.value}))} required/></Grid>
            <Grid item xs={12} md={6}><TextField fullWidth label='Slug' value={form.slug} onChange={e=>setForm(f=>({...f, slug:e.target.value}))} required/></Grid>
            <Grid item xs={12} md={6}>
              <Select fullWidth value={form.status} onChange={e=>setForm(f=>({...f, status:e.target.value}))}>
                <MenuItem value='active'>Active</MenuItem>
                <MenuItem value='inactive'>Inactive</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12}><TextField fullWidth label='Description' value={form.description} onChange={e=>setForm(f=>({...f, description:e.target.value}))}/></Grid>
            <Grid item xs={12} md={6}><TextField fullWidth label='Image URL' value={form.image} onChange={e=>setForm(f=>({...f, image:e.target.value}))}/></Grid>
            <Grid item xs={12} md={6}><TextField fullWidth label='Icon URL' value={form.icon} onChange={e=>setForm(f=>({...f, icon:e.target.value}))}/></Grid>
            <Grid item xs={12} md={6}><TextField type='number' fullWidth label='Display order' value={form.displayOrder} onChange={e=>setForm(f=>({...f, displayOrder:Number(e.target.value)}))}/></Grid>
          </Grid>
          <Stack direction='row' spacing={2} mt={3}>
            <Button type='submit' variant='contained' disabled={saving}>{saving ? 'Saving...' : 'Save'}</Button>
            <Button variant='outlined' onClick={()=>navigate('/products/categories')}>Cancel</Button>
          </Stack>
        </Box>
      </Container>
    </>
  );
}
